import React from "react";
import { upperCase } from "lodash/fp";
import { Box, styled } from "@mui/material";
import { getCarBrandSvg, CAR_BRAND_SVG_DEFAULT } from "libraries/svgPaths";

type Props = {
  licensePlate: string | undefined;
  carBrand: string;
  carModel: string;
  nextControl?: string;
};

const StyledImg = styled("img")`
  margin-left: "auto";
  margin-right: "auto";
  width: 15vw;
  height: 15vw;
  max-width: 100px;
  max-height: 100px;
`;

const StyledText = styled("div")`
  margin: 6px;
  text-align: center;
  font-weight: 500;
`;

const CarDetailsHeader = ({ carBrand, carModel, licensePlate }: Props) => (
  <>
    <Box textAlign="center" maxWidth="100">
      <StyledImg
        alt="brand-logo"
        src={getCarBrandSvg(carBrand)}
        onError={({ currentTarget }) => {
          currentTarget.onerror = null; // prevents looping
          currentTarget.src = CAR_BRAND_SVG_DEFAULT;
        }}
      />
    </Box>
    <StyledText>
      {upperCase(carBrand)} {upperCase(carModel)}
    </StyledText>
    <StyledText>{licensePlate}</StyledText>
  </>
);

export default CarDetailsHeader;
